import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

type TranslateActionErrorWithId = {
  idTranslateActionError: number;
};

// Типы для WebSocket сообщений компонента translateActionErrors
type TranslateActionErrorsListMessage = WebSocketMessageWithFields<'language-action-error-translations', {
  translateActionErrors: unknown[];
}>;
type TranslateActionErrorsListNotFoundMessage = WebSocketMessageEmpty<'language-action-error-list-not-found'>;
type TranslateActionErrorsTranslationsNotFoundMessage = WebSocketMessageEmpty<'language-action-error-translations-not-found'>;
type TranslateActionErrorCreateMessage = WebSocketMessageWithFields<'translate-action-error-create' | 'translate-action-error-create-success', TranslateActionErrorWithId & {
  idActionError: number;
  idLanguage: number;
  text: string;
}>;
type TranslateActionErrorUpdateMessage = WebSocketMessageWithFields<'translate-action-error-update' | 'translate-action-error-update-success', TranslateActionErrorWithId & {
  text: string;
}>;
type TranslateActionErrorDeleteMessage = WebSocketMessageWithFields<'translate-action-error-delete' | 'translate-action-error-delete-success', TranslateActionErrorWithId>;
type TranslateActionErrorLockMessage = WebSocketMessageWithFields<'translate-action-error-lock' | 'translate-action-error-lock-success', TranslateActionErrorWithId>;
type TranslateActionErrorUnlockMessage = WebSocketMessageWithFields<'translate-action-error-unlock' | 'translate-action-error-unlock-success', TranslateActionErrorWithId>;

// Объединенный тип для всех сообщений
type TranslateActionErrorsWebSocketMessage = 
  | TranslateActionErrorsListMessage 
  | TranslateActionErrorsListNotFoundMessage 
  | TranslateActionErrorsTranslationsNotFoundMessage 
  | TranslateActionErrorCreateMessage 
  | TranslateActionErrorUpdateMessage 
  | TranslateActionErrorDeleteMessage 
  | TranslateActionErrorLockMessage 
  | TranslateActionErrorUnlockMessage;

// WebSocket message handler

export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'dataTranslateActionErrors',
},
  __name: 'translateActionErrors',
  setup(__props) {

const store = useStore<RootState>();



// Базовый тип для сообщений с ID перевода ошибки действия
const handleWebSocketMessage = (data: TranslateActionErrorsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-action-error-translations':
      store.dispatch('translateActionErrors/wsSetTranslateActionErrors', {
        translateActionErrors: data.translateActionErrors,
      });
      break;
    case 'language-action-error-list-not-found':
      store.dispatch('action/wsSetEmptyAction');
      break;
    case 'language-action-error-translations-not-found':
      store.dispatch('actionError/wsSetEmptyActionError');
      store.dispatch('action/wsSetEmptyAction');
      break;

    case 'translate-action-error-create':
    case 'translate-action-error-create-success':
      store.dispatch('translateActionErrors/wsTranslateActionErrorCreate', {
        idTranslateActionError: data.idTranslateActionError,
        idActionError: data.idActionError,
        idLanguage: data.idLanguage,
        text: data.text,
      });
      break;

    case 'translate-action-error-update':
    case 'translate-action-error-update-success':
      store.dispatch('translateActionErrors/wsTranslateActionErrorUpdate', {
        idTranslateActionError: data.idTranslateActionError,
        text: data.text,
      });
      break;

    case 'translate-action-error-delete':
    case 'translate-action-error-delete-success':
      store.dispatch('translateActionErrors/wsTranslateActionErrorDelete', {
        idTranslateActionError: data.idTranslateActionError,
      });
      break;

    case 'translate-action-error-lock':
    case 'translate-action-error-lock-success':
      store.dispatch('translateActionErrors/wsTranslateActionErrorLock', {
        idTranslateActionError: data.idTranslateActionError,
      });
      break;

    case 'translate-action-error-unlock':
    case 'translate-action-error-unlock-success':
      store.dispatch('translateActionErrors/wsTranslateActionErrorUnlock', {
        idTranslateActionError: data.idTranslateActionError,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})